<!--人文美育-视频库管理-->
<template>
    <div class="studio_nav_content" >
        <!--五馆合一-->
        <el-scrollbar class="page-mode" v-show="showMode==='page'">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学段">
                            <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="年级">
                            <el-select clearable @change="queryClassLibrary" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
<!--                        <el-form-item label="学科">-->
<!--                            <el-select clearable @change="queryClassLibrary" v-model="queryParams.subjectKey" placeholder="请选择学科">-->
<!--                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"-->
<!--                                           :value="item.dictKey" />-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.className" placeholder="请输入教程名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQueryClass" type="primary" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="book-container">
                <div class="book-item" v-for="item in libraryList">
                    <div class="book-one" @click="viewSubjectFusion(item)">
                        <div class="book-img">
                            <img alt="" class="img-100" :src="item.coverUrl">
                        </div>
                        <div class="book-title">
                            {{ item.className }}
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <!--学科融合详情-->
        <div class="detail-mode" v-if="showMode==='subjectFusion'">
            <subject-fusion :class-id="this.classId" @change-mode="changeModel"/>
        </div>

        <!--五馆课程-->
        <div class="detail-mode" v-if="showMode==='museumCourse'">
            <museum-course :museum-key="this.museumKey" @change-mode="changeModel"/>
        </div>

        <!--搜索视频-->
        <div class="detail-mode" v-if="showMode==='searchVideo'">
            <search-humanity-video :info-word="this.keyword" @change-mode="changeModel"/>
        </div>

    </div>
</template>

<script>
import { listClassLibrary } from "@/api/admin/classLibrary";
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/public";
import subjectFusion from "@/components/resourceCentre/subjectFusion.vue";
import museumCourse from "@/components/resourceCentre/museumCourse.vue";
import searchHumanityVideo from "@/components/resourceCentre/searchHumanityVideo";

export default {
    name: "humanityMuseumHome",
    components: {subjectFusion,museumCourse,searchHumanityVideo},
    data() {
        return {
            showMode:'page',
            subjectFusionMode:'subjectFusion',
            museumCourseMode:'museumCourse',
            searchVideoMode:'searchVideo',
            serviceUrl,
            keyword:'',
            subjectList: [],
            periodList: [],
            gradeList: [],
            libraryList: [],
            queryParams: {
                className: '',
                periodKey: '1',
                gradeKey: '',
                subjectKey: '21',
            },
            classId:'',
            museumKey:'',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryDict();
        this.queryClassLibrary();
    },
    mounted(){},
    methods: {
        queryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data;
                    this.changePeriod();
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            // this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.queryClassLibrary()
        },
        changeGrade() {
            // this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.queryClassLibrary()
        },
        queryClassLibrary(){
            listClassLibrary(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.libraryList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        handleQueryClass(){
            this.queryClassLibrary();
        },
        handleQuery(){
            this.showMode = this.searchVideoMode;
            this.$emit('change-mode',this.showMode);
        },
        viewSubjectFusion(item){
            this.classId = item.classId;
            this.$emit('change-mode',this.showMode);
            this.showMode = this.subjectFusionMode
        },
        viewMuseum(mk){
            this.museumKey = mk;
            this.$emit('change-mode',this.showMode);
            this.showMode = this.museumCourseMode
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.form-box{
    padding: 10px 20px 0 0;
    height: 40px;
}
.head-container-top{
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 18px;
    color: #121212;
    line-height: 30px;
    font-weight: bold;
}
.head-container{
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 18px;
    color: #121212;
    line-height: 40px;
    font-weight: bold;
}
.museum-container{
    width: 100%;
    height: calc(100vh - 160px);
    padding: 0 30px 0 30px;
    box-sizing: border-box;
    display: flex;
}
.museum-item{
    width: 20%;
    height: 100%;
    padding: 0 12px 0 12px;
    box-sizing: border-box;
    display: grid; place-items: center;
}
.museum-img{
    width: 100%;
    cursor: pointer;
    border: 1.5px solid #f1f1f1;
}
.book-container{
    width: 100%;
    height: auto;
    padding: 20px 30px 20px 30px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.book-item{
    width: 20%;
    height: 100%;
    padding: 0 20px 10px 20px;
    box-sizing: border-box;
}
.book-one{
    width: 100%;
    height: 100%;
    padding: 8px;
    border: 1.5px solid #f1f1f1;
}
.book-one:hover{
    border: 1.5px solid #ff7f2e!important;
    color: #ff7f2e!important;
    font-weight: bold;
}
.book-img{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.book-title{
    height: 44px;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding: 0 5px 5px 5px;
    cursor: pointer;
}
</style>